/**
 * Layer which adds standard controls to the map widget
 */
export default class Controls {
    private element: HTMLDivElement;

    constructor(baseMapModule, overlayModule, eventChannel) {
        const loc = es.util.TrackingEvents.getLocation(window.location.href);

        const element = document.createElement("div");

        $(element).addClass('es-map-controls');

        const standardControls = $('<div />', {'class':'es-map-control-standardControls '}).append(
            $('<div />', {
                'class': 'es-map-control-btn es-map-control-btn-zoomToArea unselectable',
                'title': $i18n('Zoom_to_area')
            }).html("&#9608;").on('click', function() {
                es.util.TrackingEvents.push([loc +'.Map_Interaction.Zoom_To_Area']);
                const e = $(this);
                if (e.hasClass("es-map-control-btn-active")) {
                    baseMapModule.cancelZoomToArea();
                } else {
                    baseMapModule.beginZoomToArea();
                }
            })
        ).append(
            $('<div />', {
                'class': 'es-map-control-btn es-map-control-btn-geolocate unselectable',
                'title': $i18n('Show_my_location')
            }).html("&#9608;").on('click', () => {
                es.util.TrackingEvents.push([loc +'.Map_Interaction.Geolocate']);
                es.util.geoLocateAndZoom(baseMapModule, overlayModule);
            })
        ).append(
            $('<div />', {
                'class': 'es-map-control-btn es-map-control-btn-resetView unselectable',
                'title': $i18n('Reset_PitchAndBearing')
            }).html("&#9608;").on('click', () => {
                es.util.TrackingEvents.push([loc +'.Map_Interaction.resetPitchAndBearing']);
                baseMapModule.resetPitchAndBearing();
            })
        ).append(
            $('<div />', {
                'class': 'es-map-control-btn es-map-control-btn-zoomIn unselectable',
                'title': $i18n('Zoom_in')
            }).html("&#9608;").on('click', () => {
                baseMapModule.setZoomBy(1);
            })
        ).append(
            $('<div />', {
                'class': 'es-map-control-btn es-map-control-btn-zoomOut unselectable',
                'title': $i18n('Zoom_out')
            }).html("&#9608;").on('click', () => {
                baseMapModule.setZoomBy(-1);
            })
        );

        $(element)/*.append(territoryControls)*/.append(standardControls);

        eventChannel.addListener("onBeginZoomToArea", () => {
            $(element).find(".es-map-control-btn-zoomToArea").addClass("es-map-control-btn-active");
        }).addListener("onFinishZoomToArea", () => {
            $(element).find(".es-map-control-btn-zoomToArea").removeClass("es-map-control-btn-active");
        });

        $(element).find(".unselectable").attr("unselectable", "on");

        this.element = element;
    }

    appendTo(parentElement: HTMLElement) {
        parentElement.appendChild(this.element);
    }

    /*
    appendTo(parentElement, beforeElement, newSize) {
        if (beforeElement) {
            parentElement.insertBefore(this.element, beforeElement);
        } else {
            parentElement.appendChild(this.element);
        }
    }

    removeFrom(parentElement) {
        parentElement.removeChild(element);
    }

    getPriority() {
        return 300;
    }

    destroy() {
        $(this.element).remove();
        this.element = null;
    };
    */
}
